import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { Controller } from 'react-hook-form';

import { tinymceExtendedValidElements } from '@constants';
import { FormError, HelpText } from '@Forms/fields.jsx';

const SimpleHTMLField = ({
  control,
  error,
  editorRefs,
  height = 250,
  helpText,
  initialValue,
  label,
  name,
  register,
  ...props
}) => {
  // HTML field with simple styling controls
  return (
    <div
      className={
        `sb-form-item-formgroup sb-form-item-input ` +
        (error ? 'sb-form-item-error' : '')
      }
    >
      {label && <label htmlFor={name}>{label}</label>}
      <div className="sb-form-item-content">
        <Controller
          control={control}
          name={name}
          min_height={height}
          height={height}
          render={({ field }) => (
            <Editor
              tinymceScriptSrc="/assets/tinymce/tinymce.min.js"
              licenseKey="gpl"
              onInit={(_evt, editor) => (editorRefs[name] = editor)}
              value={field.value ?? initialValue ?? ''}
              onEditorChange={field.onChange}
              init={{
                height: height,
                menubar: false,
                plugins: [
                  'advlist',
                  'autolink',
                  'lists',
                  'link',
                  'image',
                  'charmap',
                  'preview',
                  'anchor',
                  'searchreplace',
                  'visualblocks',
                  'code',
                  'fullscreen',
                  'insertdatetime',
                  'media',
                  'table',
                  'code',
                  'help',
                  'wordcount',
                ],
                toolbar:
                  'undo | blocks | bold italic link | bullist numlist outdent indent | removeformat | help',
                extended_valid_elements: tinymceExtendedValidElements.join(','),
                content_style:
                  'body { font-family: Inter, system-ui, Avenir, Helvetica, Arial, sans-serif; line-height: 1.5; font-weight: 400; }',
              }}
              {...props}
            />
          )}
        />
        {helpText && <HelpText message={helpText} />}
        {error && <FormError message={error.message} />}
      </div>
    </div>
  );
};

export default SimpleHTMLField;
